import React from "react";

export default function FileIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.50017 2H3.49998C3.36737 2 3.2402 2.05268 3.14643 2.14645C3.05267 2.24022 3 2.3674 3 2.5V13.5C3 13.6326 3.05267 13.7598 3.14643 13.8535C3.2402 13.9473 3.36737 14 3.49998 14H12.5C12.6326 14 12.7598 13.9473 12.8536 13.8535C12.9473 13.7598 13 13.6326 13 13.5V5.5M9.50017 2L13 5.5M9.50017 2L9.5 5.5H13"
        stroke="#4A72FF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
